import { Space } from '@cashfree-intl/coherent';
import styled from 'styled-components';

export const StyledBackButton = styled(Space)`
  cursor: pointer;
`;
